import React, { useRef, useEffect } from 'react';
import { Check } from 'lucide-react';
import { ResponsiveOverlay } from '@/components/ui/ResponsiveOverlay';
import { SelectOption } from './Select';

interface SelectPopoverProps {
  isOpen: boolean;
  setIsOpen: (isOpen: boolean) => void;
  options: SelectOption[];
  value: string;
  onChange: (value: string) => void;
  title?: string;
  placeholder?: string;
  dropdownRef: React.RefObject<HTMLDivElement | null>;
}

export function SelectPopover({
  isOpen,
  setIsOpen,
  options,
  value,
  onChange,
  title,
  placeholder,
  dropdownRef
}: SelectPopoverProps) {
  return (
    <ResponsiveOverlay
      isOpen={isOpen}
      onClose={() => setIsOpen(false)}
      variant="dropdown"
      className="p-4 sm:p-1 w-full"
      isPortal={false}
      style={{}}
    >
      <div ref={dropdownRef} className="flex flex-col w-full gap-1">
        <h3 className="text-lg font-semibold text-slate-900 dark:text-white mb-3 sm:hidden px-2">{title || placeholder || 'Select Option'}</h3>
        
        {options.map((loc) => (
          <button
            key={loc.value}
            type="button"
            onClick={() => {
              onChange(loc.value);
              setIsOpen(false);
            }}
            className={`w-full flex items-center justify-between gap-3 px-4 sm:px-3 py-3 sm:py-2 text-base sm:text-sm text-left rounded-lg sm:rounded-md cursor-pointer ${
              value === loc.value 
                ? 'bg-emerald-50 dark:bg-emerald-500/10 text-emerald-600 dark:text-emerald-400 font-medium' 
                : 'text-slate-700 dark:text-slate-300 hover:bg-slate-100 dark:hover:bg-slate-800'
            }`}
          >
            <span className="truncate">{loc.label}</span>
            {value === loc.value && <Check className="w-4 h-4 text-emerald-500" />}
          </button>
        ))}
      </div>
    </ResponsiveOverlay>
  );
}
